// extracted by mini-css-extract-plugin
export default {"main_section":"modal_main_section__ES9CQ","model_button":"modal_model_button__oo8aw"};